module.exports = __webpack_public_path__ + "img/img_15.606111c8.jpg";